/* OS popup-fix (okt 2026)
   Klaviyo-popuparna (Välkomst Vshphc och Halloween TTymcz): valet i första steget sparas,
   och "Börja handla" i sista steget leder till en kategori som passar valet. */
(function () {
  'use strict';
  var KEY = 'osIntresse';
  var MAP = {
    'något till mig': '/collections/bastsaljare',
    'något till oss': '/collections/for-par',
    'en present': '/collections/kit',
    'godis, tack': '/collections/bastsaljare',
    'bus': '/collections/bdsm'
  };
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('button, [role="button"], a');
    if (!b || !b.closest('[class*="kl-private-reset-css"]')) return;
    var label = txt(b);
    if (MAP[label]) { ss(KEY, MAP[label]); return; }
    if (label === 'börja handla') {
      var dest = ss(KEY);
      if (dest) {
        e.preventDefault();
        e.stopImmediatePropagation();
        location.href = dest + '?utm_source=klaviyo&utm_medium=popup&utm_campaign=popup-val';
      }
    }
  }, true);
})();
